import React from "react";
import { X } from "lucide-react";
import AuditHistory from "../../components/AuditHistory";

export default function ApiKeyHistoryModal({ apiKey, onClose }) {
  if (!apiKey) return null;

  return (
    <div className="jfm-overlay" onClick={onClose}>
      <div
        className="jfm-container audit-history-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="jfm-header">
          <span className="jfm-title">History — {apiKey.name}</span>
          <button className="jfm-close" onClick={onClose}>
            <X size={18} />
          </button>
        </div>

        <div className="jfm-body">
          <AuditHistory
            resource="company_keys"
            uuid={apiKey.uuid}
            createdAt={apiKey.created_at}
          />
        </div>
      </div>
    </div>
  );
}
